import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=42fcbb62&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=ts"
export * from "./knowledge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fcbb62",
  null
  
)

export default component.exports